@if (confirmService.visible()) {
  <elcia-dialog
    (onClose)="confirmService.reject()"
    (onDelete)="confirmService.accept()"
    [mustDisplayActionButton]="false"
    [mustDisplayDeleteButton]="true"
    [size]="'x-small'"
    [title]="confirmService.title()"
  >
    <div class="font-medium">
      {{ 'delete.confirm' | translate }}
    </div>
    <br>
    <div class="font-medium wrap-break-word">{{ confirmService.message() }}</div>
  </elcia-dialog>
}
